import { render, staticRenderFns } from "./SigningPersonRules.vue?vue&type=template&id=7839dd3c&scoped=true&"
import script from "./SigningPersonRules.vue?vue&type=script&lang=js&"
export * from "./SigningPersonRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7839dd3c",
  null
  
)

export default component.exports